import { render, staticRenderFns } from "./BusinessSummary.vue?vue&type=template&id=fa15f766&scoped=true&lang=pug"
import script from "./BusinessSummary.coffee?vue&type=script&lang=coffee&external"
export * from "./BusinessSummary.coffee?vue&type=script&lang=coffee&external"
import style0 from "./BusinessSummary.sass?vue&type=style&index=0&id=fa15f766&prod&lang=sass&scoped=true&external"
import style1 from "./BusinessSummary.vue?vue&type=style&index=1&id=fa15f766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa15f766",
  null
  
)

export default component.exports